import { useEffect, useState } from 'react';
import { ResponsiveContainer, LineChart, Line, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, PieChart, Pie, Cell } from 'recharts';
import { analyticsApi } from '../../api/admin.js';
import { pmApi } from '../../api/pm.js';

const COLORS = ['#94a3b8', '#2563eb', '#f59e0b', '#16a34a', '#9333ea'];

export default function ProjectAnalytics() {
  const [projects, setProjects] = useState([]);
  const [pid, setPid] = useState(null);
  const [data, setData] = useState(null);

  useEffect(() => { pmApi.projects().then((d) => { setProjects(d?.items || []); if (d?.items?.[0]) setPid(d.items[0].id); }); }, []);
  useEffect(() => { if (pid) analyticsApi.project(pid).then(setData); }, [pid]);

  if (!projects.length) return <div className="muted">No projects yet.</div>;

  return (
    <section>
      <header className="page-header">
        <h1>Project Analytics</h1>
        <select value={pid || ''} onChange={(e) => setPid(e.target.value)}>
          {projects.map((p) => <option key={p.id} value={p.id}>{p.key} · {p.name}</option>)}
        </select>
      </header>

      {!data ? <div className="muted">Loading…</div> : (
        <div className="grid-2">
          <div className="card">
            <h3>Sprint burndown</h3>
            {data.burndown ? (
              <ResponsiveContainer width="100%" height={260}>
                <LineChart data={data.burndown.days.map((d, i) => ({ day: d.slice(5), ideal: data.burndown.ideal[i], actual: data.burndown.actual[i] }))}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="day" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="ideal" stroke="#94a3b8" strokeDasharray="4 4" />
                  <Line type="monotone" dataKey="actual" stroke="#2563eb" strokeWidth={2} />
                </LineChart>
              </ResponsiveContainer>
            ) : <div className="muted">No active sprint.</div>}
          </div>

          <div className="card">
            <h3>Velocity (last sprints)</h3>
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={data.velocity}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="sprint" />
                <YAxis />
                <Tooltip />
                <Bar dataKey="points" fill="#16a34a" />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div className="card">
            <h3>Issue status distribution</h3>
            <ResponsiveContainer width="100%" height={220}>
              <PieChart>
                <Pie data={data.distribution} dataKey="count" nameKey="status" outerRadius={80} label>
                  {data.distribution.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
                </Pie>
                <Tooltip />
              </PieChart>
            </ResponsiveContainer>
          </div>

          <div className="card">
            <h3>Team workload (this month)</h3>
            <ResponsiveContainer width="100%" height={220}>
              <BarChart data={data.workload} layout="vertical">
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis type="number" />
                <YAxis type="category" dataKey="name" width={100} />
                <Tooltip />
                <Bar dataKey="hours" fill="#2563eb" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}
    </section>
  );
}
